import { capitalizeFirstLetterOnly } from '@/helpers/dataHelper';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { memo } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';

import dynamic from 'next/dynamic';
const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'), { ssr: false });
const SEO = dynamic(() => import('@/components/landing/seo'), { ssr: false });
const NoteSubjectsLanding = dynamic(() => import('@/components/landing/notes/subject'));

const NoteSubjectsComponent = (props) => {
  const subjectImage = useSelector(
    (state: RootStateOrAny) => state?.notes?.landingNoteSubjectDetail?.data?.image
  );

  return (
    <>
      <Head>
        <title>Subjects | Learnsic</title>
        <link
          rel="canonical"
          href={`${process.env.NEXT_PUBLIC_SITE_URL}notes/${props?.slug}/subjects`}
        />
      </Head>
      <SEO
        meta_title={`Note ${capitalizeFirstLetterOnly(
          props?.slug
        )} Subjects | Learnsic`}
        meta_description={'Learnsic note subjects'}
        meta_keywords={
          'Learnsic notes, Subject notes, Notes in Nepal, Online notes in Nepal, Notes Subjects'
        }
        photo={subjectImage || '/images/notesplaceholder.png'}
        canonical="notes"
      />
      <LandingLayout>
        <NoteSubjectsLanding courseSlug={props?.slug} />
      </LandingLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  params: { courseSlug },
}) => {
  return {
    props: {
      slug: courseSlug,
    },
  };
};

export default memo(NoteSubjectsComponent);
